import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05e3829d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/favicon.png",
  alt: "logo",
  class: "title-logo"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml16 ft18 boldFont"
}, "速记星超常儿童智力甄别和训练系统", -1));
const _hoisted_4 = {
  class: "bigFont mr16"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft10 mt8"
}, "v1.1.6", -1));
const _hoisted_6 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_7 = {
  style: {
    "width": "200px",
    "box-sizing": "border-box"
  }
};
const _hoisted_8 = {
  style: {
    "width": "calc(100% - 200px)",
    "box-sizing": "border-box"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_header = _resolveComponent("el-header");
  const _component_AsideMenu = _resolveComponent("AsideMenu");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "header"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "wd100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_2, _hoisted_3]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [$data.user.userTag == 'ADMIN' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_button, {
            style: {
              "background-color": "#E5F1FE",
              "border": "none",
              "color": "#999999"
            },
            onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/'))
          }, {
            default: _withCtx(() => [_createTextVNode("学生视角")]),
            _: 1
          }), _createVNode(_component_el_button, {
            style: {
              "background-color": "#E5F1FE",
              "border": "none",
              "color": "#3269FF"
            },
            onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/m')),
            class: "ml16 mr16"
          }, {
            default: _withCtx(() => [_createTextVNode("管理员视角")]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_4, "hello," + _toDisplayString($data.user.nickName), 1), _createVNode(_component_el_popover, {
            trigger: "click"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
              _: 1
            })]),
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                style: {
                  "width": "100%"
                },
                onClick: $options.logout
              }, {
                default: _withCtx(() => [_createTextVNode("退出登录")]),
                _: 1
              }, 8, ["onClick"]), _hoisted_5]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_AsideMenu)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_router_view)])])]),
    _: 1
  })]);
}